const frDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "Cloner le dépôt",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "Télécharger en ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "Gérer les clés SSH",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "Ce répertoire est vide",
    description: "Message shown when directory has no contents",
  },
};

export default frDirectoryBrowse;
